export default "__VITE_ASSET__50Wz8wF3__"